/* Agora Low Quality Video Stream
 * - Equivalent of 180p_1
 */
export const VIDEO_LOW_STREAM_CONFIG = {
  width: 320,
  height: 180,
  framerate: 15,
  bitrate: 140
};

/*
 * Agora setStreamFallbackOption fallbackType
 * - Under poor network, the SDK may subscribe to the low-quality video stream (of lower resolution and lower bitrate) first,
 * - but if the network still does not allow displaying the video, the SDK will receive audio only
 */
export const AUDIO_ONLY_FALLBACK = 2;

/*
 * Agora Network Quality
 * - 0: The quality is unknown.
 * - 1: The quality is excellent.
 * - 2: The quality is good, but the bitrate is less than optimal.
 * - 3: Users experience slightly impaired communication.
 * - 4: Users can communicate with each other, but not very smoothly.
 * - 5: The quality is so poor that users can barely communicate.
 */
export const NETWORK_QUALITY = {
  unknown: 0,
  excellent: 1,
  good: 2,
  fair: 3,
  poor: 4,
  bad: 5
};

export const BANDWIDTH_THRESHOLDS = {
  excellent: {
    profile: '360p_4',
    label: 'excellent',
    value: NETWORK_QUALITY.excellent
  },
  good: {
    profile: '240p',
    label: 'good',
    value: NETWORK_QUALITY.fair
  },
  moderate: {
    profile: '180p_1',
    label: 'moderate',
    value: NETWORK_QUALITY.poor,
  },
  poor: {
    profile: '180p_1',
    label: 'poor',
    value: NETWORK_QUALITY.bad
  }
};

/*
 * Agora stream type
 * - 0: High-bitrate, high-resolution video stream.
 * - 1: Low-bitrate, low-resolution video stream.
 */
export const STREAM_TYPE = {
  high: 0,
  low: 1
};

/*
 * Custom timeout (in milliseconds) for the Agora WebRTC join process.
 * If a join attempt does not complete within this window, MyStage forcefully
 * aborts the attempt, cleans up any stale connection state, and retries —
 * rather than waiting for the Agora SDK's built-in timeout, which can take up
 * to ~20 minutes to surface a failed connection.
 */
export const JOIN_TIMEOUT_MS = 20000;

/*
 * Maximum number of join attempts (including the first) before the failure is
 * surfaced to the user as an unexpected error.
 */
export const MAX_JOIN_ATTEMPTS = 3;

/*
 * Case-insensitive regex of error code/message tokens that classify a join
 * failure as retryable (transient network issue). Includes Agora SDK tokens,
 * the custom NETWORK_TIMEOUT (from the Timeout Guard), OPERATION_ABORTED
 * (from a left client after cleanup), and the MyStage-specific
 * MYSTAGE_JOIN_ABORTED token.
 */
export const RETRYABLE_PATTERNS = /network|timeout|disconnect|server_error|NETWORK_ERROR|NETWORK_TIMEOUT|CAN_NOT_GET_GATEWAY_SERVER|CAN_NOT_GET_PROXY_SERVER|OPERATION_ABORTED|WS_ABORT|WS_DISCONNECT|ERR_NETWORK|MYSTAGE_JOIN_ABORTED/i;

/*
* Reconnecting-overlay recovery poll.
* When Agora fires DISCONNECTED while navigator.onLine is true, we do NOT trust
* navigator.onLine alone (it can stay true on multi-homed machines after Wi-Fi is
* turned off). Instead we ping the backend on this interval and only dismiss the
* overlay once a ping actually succeeds. Each ping is raced against a timeout so a
* stalled request does not block the loop.
*/
export const RECONNECT_RECOVERY_PING_INTERVAL_MS = 3000;
export const RECONNECT_RECOVERY_PING_TIMEOUT_MS = 5000;

/*
* Buffer count for downgrade decisions (switching to lower quality tier)
*/
export const BUFFER_SWITCH_DOWNGRADE_COUNT = 3;

/*
* Buffer count for upgrade decisions (switching to higher quality tier)
*/
export const BUFFER_SWITCH_UPGRADE_COUNT = 6;

/* Agora Low Quality Video Stream - 240p
 * - Used for mid-range bandwidth users (1000-2000 kbps)
 */
export const VIDEO_LOW_STREAM_CONFIG_240P = {
  width: 426,
  height: 240,
  framerate: 15,
  bitrate: 300
};

/*
 * Minimum measured bandwidth (kbps) required to enable dual-stream on join.
 * Below this, dual-stream is deferred to the runtime uplink upgrade path to
 * avoid a sender-side upload spike on constrained networks.
 */
export const DUAL_STREAM_MIN_BANDWIDTH = 1300;
